import { gql } from '@apollo/client';

const DELETE_FIGURE = gql`mutation deleteFigure($figureId:Int!) {
	resourceComments{
		deleteFigure (id: $figureId)
	}
}`;

export default DELETE_FIGURE;
